import React from 'react';

import { TOOL_IDS, useCurrentProject } from '@adsk/alloy-provider';

import { isPluginProductOrToolNotAvailableInEntitlements } from '../../../helpers/isPluginProductOrToolNotAvailableInEntitlements';
import { getProductId } from '../helpers/utils';

const SheetsCommonContext = React.createContext({});

const useSheetsCommon = () => React.useContext(SheetsCommonContext);

const SheetsCommonProvider = ({
  children,
  sheetContainerType = 'Build',
  sheetParser,
}) => {
  const currentProject = useCurrentProject();
  const isPluginEnabled = !isPluginProductOrToolNotAvailableInEntitlements({
    plugin: {
      productId: getProductId(sheetContainerType),
      toolId: TOOL_IDS.SHEETS,
    },
    currentProject,
  });

  const value = {
    sheetContainerType,
    sheetParser,
    isPluginEnabled,
  };

  return (
    <SheetsCommonContext.Provider value={value}>
      {children}
    </SheetsCommonContext.Provider>
  );
};

SheetsCommonProvider.displayName = 'SheetsCommonProvider';

export { useSheetsCommon, SheetsCommonProvider };
